export default {
  meta: {
    title: '实验管理',
  },
};
